<template>
    <w-btn
        v-if="show"
        :color="error ? 'red' : 'cyan'"
        :loading="loading"
        :disabled="disabled"
        :text="$t('common.launch')"
        :icon="error ? 'mdi-alert' : 'mdi-clock-start'"
        @press="press"
    />
</template>

<script>
export default {
    name: 'WBtnLaunch',
    props: {
        show: Boolean,
        loading: Boolean,
        disabled: Boolean,
        error: Boolean,
    },
    emits: ['press'],
    setup(props, {emit}) {
        function press() {
            emit('press');
        }

        return {
            press,
        }
    }
}
</script>

<style scoped>

</style>